import { render, staticRenderFns } from "./AtomDoughnutChart.vue?vue&type=template&id=3f15ec37&scoped=true&"
import script from "./AtomDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./AtomDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./AtomDoughnutChart.vue?vue&type=style&index=0&id=3f15ec37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f15ec37",
  null
  
)

export default component.exports